// import { ElMessage } from 'element-ui'
import _ from 'lodash'
import Http from "./Http";
import AppConfig from "../../../../config/AppConfig";

let typeList = [] //[{id,name,pindex_ids}]
let place_list = [] //[{id,name,zone_ids,project_ids}]
let regionList = [] //[{id,name,pid,pindex_id,pindex_ids}]
let projectList = [] //[{erp_pindex_id,house_id,house_name,level,type}]
let projectIds = [] //[1,2,3,4,5]
let areaList = []  //[{erp_pindex_id,house_id,house_name}]

export default class UserProjectInfo {
  // 获取会员项目信息
  static ready (callback, status = 1) {
    Http.get(AppConfig.flow_server + '/hrm/User/getUserProjectInfo', {
      show_place:1
    }, res => {
      if (!res.code) {

        areaList = res.data.area_list
        projectList = res.data.project_list
        regionList = res.data.region_list
        typeList = res.data.type_list

        place_list = res.data.place_list.map(item => {
          let _regionList = regionList.filter(region => item.zone_ids.includes(region.id))
          let _projectIds=[];
          if(_regionList.length>0){
            _regionList.forEach(region => {
              _projectIds = _projectIds.concat(region.pindex_ids)
            })
          }
          _projectIds=_.uniq(_projectIds) //去重
          item.project_ids = _projectIds.map(id => id + '')
          return item
        });
        projectIds = res.data.project_ids.map(id => id + '')
        if(callback) callback()
      }else {
        // ElMessage.error(res.msg)
      }
    })
  }

  // 获取项目类型列表
  static getTypeList() {
    return typeList
  }

  // 获取大区域列表
  static getPlaceList(type_id=0) {
    const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
    return place_list.filter(item => _.intersection(typeProjectIds, item.project_ids).length > 0)
  }

  // 获取大区域战区ID
  static getReginIdsByPlace(place_id=0) {
    return place_list.find(item => item.id == place_id).zone_ids
  }

  // 获取大区域战区项目id列表
  static getProjectIdsByPlace(place_id=0) {
    return place_list.find(item => item.id == place_id).project_ids
  }


  //// 战区 ////

  // 通过项目类型，获取战区列表
  static getRegionList({type_id, place_id}) {
    if(type_id && place_id){
      const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
      const placeProjectIds = UserProjectInfo.getProjectIdsByPlace(place_id)
      const project_ids = _.intersection(typeProjectIds, placeProjectIds) // 交集
      const list = regionList.filter(item => _.intersection(project_ids, item.pindex_ids).length > 0)
      return UserProjectInfo.getRegionTree(0, list)
    }else if(type_id) {
      const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
      const project_ids = _.intersection(projectIds, typeProjectIds)
      const list = regionList.filter(item => _.intersection(project_ids, item.pindex_ids).length > 0)
      return UserProjectInfo.getRegionTree(0, list)
    } else {
      return UserProjectInfo.getRegionTree(0, regionList)
    }
  }

  static getRegionLevel(region_id) {
    if(!region_id){
      return 0
    }
    return (regionList.find(item => item.id === region_id)||{}).pid?2:1
  }


  //// 项目 ////

  // 获取项目
  static getProjectList({region_id,place_id, type_id}) {
    if (region_id && place_id && type_id) {
      const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
      const placeProjectIds = UserProjectInfo.getProjectIdsByPlace(place_id)
      const regionProjectIds = UserProjectInfo.getProjectIdsByRegionId(region_id)
      return projectList.filter(item =>
        regionProjectIds.includes(item.erp_pindex_id+'') &&
        placeProjectIds.includes(item.erp_pindex_id+'') &&
        typeProjectIds.includes(item.erp_pindex_id+'')
      )
    }
    if (!region_id && place_id && type_id) {
      const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
      const placeProjectIds = UserProjectInfo.getProjectIdsByPlace(place_id)
      return projectList.filter(item =>
        placeProjectIds.includes(item.erp_pindex_id+'') &&
        typeProjectIds.includes(item.erp_pindex_id+'')
      )
    }
    if (region_id && type_id) {
      const regionProjectIds = UserProjectInfo.getProjectIdsByRegionId(region_id)
      const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
      return projectList.filter(item => regionProjectIds.includes(item.erp_pindex_id+'') && typeProjectIds.includes(item.erp_pindex_id+''))
    }
    if (region_id) {
      const regionProjectIds = UserProjectInfo.getProjectIdsByRegionId(region_id)
      return projectList.filter(item => regionProjectIds.includes(item.erp_pindex_id+''))
    }
    if (place_id) {
      const project_ids = UserProjectInfo.getProjectIdsByPlace(place_id)
      return projectList.filter(item => project_ids.includes(item.erp_pindex_id+''))
    }
    if (type_id) {
      const typeProjectIds = UserProjectInfo.getProjectIdsByTypeId(type_id)
      return projectList.filter(item => typeProjectIds.includes(item.erp_pindex_id+''))
    }
    return projectList
  }

  // 获取项目id列表
  static getProjectIds({region_id,place_id, type_id}) {
    let project_list = UserProjectInfo.getProjectList({region_id,place_id, type_id})
    return project_list.map(item => item.erp_pindex_id).join(',')
  }

  // 获取战区项目id列表
  static getProjectIdsByRegionId(id) {
    let region = regionList.find(item => item.id == id)
    if(!region) return []
    return region.pindex_ids||[]
  }

  // 获取类型项目id列表
  static getProjectIdsByTypeId(id) {
    let type = typeList.find(item => item.id == id)
    if(!type) return []
    return type.pindex_ids||[]
  }

  // 战区列表转为树结构
  static getRegionTree(id, d) {
    let list = []
    for(const k in d) {
      if(d[k].pid == id) {
        let item = d[k]
        item.children = UserProjectInfo.getRegionTree(item.id, d)
        list.push(item)
      }
    }
    return list
  }


  //// 区域 ////
  static getAreaList(id) {
    return id ? areaList.filter(item => item.erp_pindex_id == id) : []
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/common/UserProjectInfo.js